import { UPDATE_FEEDBACK_LIST } from "../../store/actionTypes";

const initialState = {
  isLoading: false,
  total: 0,
  pageNo: 1,
  limit: 10,
  totalPage: 0,
  dataList: [],
  sortOrder: 0,
  sortBy: "createdAt",
  status: "",
};

const FeedbackReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_FEEDBACK_LIST:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
export default FeedbackReducer;
